export const DEFAULT_UPDATE_FREQUENCY_HOURS = 24;
export const MIN_UPDATE_FREQUENCY_HOURS = 1;
export const MAX_UPDATE_FREQUENCY_HOURS = 24;

/** Default: 30 days from today (YYYY-MM-DD) */
export function getDefaultUpdateTillDate(): string {
  const d = new Date();
  d.setDate(d.getDate() + 30);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function clampFrequencyHours(hours: number): number {
  return Math.min(
    MAX_UPDATE_FREQUENCY_HOURS,
    Math.max(
      MIN_UPDATE_FREQUENCY_HOURS,
      Math.round(hours) || DEFAULT_UPDATE_FREQUENCY_HOURS
    )
  );
}

export function formatUpdateTill(isoDate: string): string {
  if (!isoDate) return "—";
  const d = new Date(
    isoDate.includes("T") ? isoDate : `${isoDate}T00:00:00`
  );
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

export function formatFrequencyHours(hours: number): string {
  if (!Number.isFinite(hours) || hours <= 0) return "—";
  const h = Math.round(hours);
  return h === 1 ? "Every 1 hour" : `Every ${h} hours`;
}

export type ReportUpdateConfigValue = {
  updateTillDate: string;
  updateForIntervalHourFrequency: number;
};

export function getDefaultReportUpdateConfig(): ReportUpdateConfigValue {
  return {
    updateTillDate: getDefaultUpdateTillDate(),
    updateForIntervalHourFrequency: DEFAULT_UPDATE_FREQUENCY_HOURS,
  };
}
